// functions/index.js - Auto-export all functions organized by category
export * from './math/index.js';
export * from './graphics/index.js';
export * from './color/index.js';
export * from './utils/index.js';
export * from './math.js';
